<app-card-consulta
  (update)="update.emit($event)"
  [titulo]="titulo"
  [idConsulta]='idConsulta'
  [tipoConsulta]="tipoConsulta"
  [codigoControle]="codigoControle"
  [status]="status"
  [msg]="statusMsg"
  [token]="token"
>

<ng-container *ngIf="consulta">

  <h2 class="subtitle text-uppercase">Dados cadastrais</h2>
  <ul class="card-list-striped">
    <li><span class="text-secondary">Placa </span><span>{{consulta?.placa || 'NÃO INFORMADO'}}</span></li>
    <li><span class="text-secondary">Chassi </span><span>{{consulta?.chassi || 'NÃO INFORMADO'}}</span></li>
    <li><span class="text-secondary">Número do motor original
      </span><span>{{consulta?.numeroMotor || 'NÃO INFORMADO'}}</span></li>
    <li><span class="text-secondary">Número do motor atual
      </span><span>{{consulta?.FALTA || 'NÃO INFORMADO'}}</span></li>
    <li><span class="text-secondary">Número cx do câmbio
      </span><span>{{consulta?.nrCaixaCambio || 'NÃO INFORMADO'}}</span></li>
    <li><span class="text-secondary">Potência </span><span>{{consulta?.potencia || 'NÃO INFORMADO'}}</span>
    </li>
    <li><span class="text-secondary">Cilindradas
      </span><span>{{consulta?.cilindradas || 'NÃO INFORMADO'}}</span></li>
    <li><span class="text-secondary">Tipo doc faturado
      </span><span>{{consulta?.tipoDocFaturado || 'NÃO INFORMADO'}}</span></li>
    <li><span class="text-secondary">Número faturado
      </span><span>{{consulta?.numeroFaturado || 'NÃO INFORMADO'}}</span></li>
    <li><span class="text-secondary">Data última atualização
      </span>
      <span>{{(consulta?.dataUltimaAtualizacao | date: 'dd/MM/yyyy') ? (consulta?.dataUltimaAtualizacao | date: 'dd/MM/yyyy') : 'NÃO INFORMADO'}}</span></li>
    <li><span class="text-secondary">Município / UF </span><span>{{consulta?.municipio || 'NÃO INFORMADO'}} /
        {{consulta?.ufMunicipio || 'NÃO INFORMADO'}}</span></li>
    <li><span class="text-secondary">UF Faturado
      </span><span>{{consulta?.ufFaturado || 'NÃO INFORMADO'}}</span></li>
    <li><span class="text-secondary">CPF/CNPJ Faturado
      </span><span>{{consulta?.cpfCnpjComprador || 'NÃO INFORMADO'}}</span></li>
  </ul>

  <h2 class="subtitle text-uppercase">Descrição do veículo</h2>
  <ul class="card-list-striped">
    <li><span class="text-secondary">Marca / Modelo </span><span>{{consulta?.marca || 'NÃO INFORMADO'}} /
        {{consulta?.modelo || 'NÃO INFORMADO'}}</span></li>
    <li><span class="text-secondary">Ano de fabricação
      </span><span>{{consulta?.anoFabricacao || 'NÃO INFORMADO'}}</span></li>
    <li><span class="text-secondary">Ano do modelo
      </span><span>{{consulta?.anoModelo || 'NÃO INFORMADO'}}</span></li>
    <li><span class="text-secondary">Combustível
      </span><span>{{consulta?.combustivel || 'NÃO INFORMADO'}}</span></li>
    <li><span class="text-secondary">Cor </span><span>{{consulta?.cor || 'NÃO INFORMADO'}}</span></li>
    <li><span class="text-secondary">Espécie
      </span><span>{{consulta?.especieVeiculo || 'NÃO INFORMADO'}}</span></li>
    <li><span class="text-secondary">Número de passageiros
      </span><span>{{consulta?.capacidadePassageiro || 'NÃO INFORMADO'}}</span></li>
    <li><span class="text-secondary">Categoria </span><span>{{consulta?.categoria || 'NÃO INFORMADO'}}</span>
    </li>
    <li><span class="text-secondary">Segmento </span><span>{{consulta?.segmento || 'NÃO INFORMADO'}}</span>
    </li>
    <li><span class="text-secondary">Situação Chassi
      </span><span>{{consulta?.situacaoChassi || 'NÃO INFORMADO'}}</span></li>
  </ul>

  <h2 class="subtitle text-uppercase">Ficha técnica</h2>
  <ul class="card-list-striped">
    <li><span class="text-secondary">Subsegmento
      </span><span>{{consulta?.subSegmento || 'NÃO INFORMADO'}}</span></li>
    <li><span class="text-secondary">Tipo montagem
      </span><span>{{consulta?.tipoMontagem || 'NÃO INFORMADO'}}</span></li>
    <li><span class="text-secondary">Tipo de veículo
      </span><span>{{consulta?.tipoVeiculo || 'NÃO INFORMADO'}}</span></li>
    <li><span class="text-secondary">Tipo de carroceria
      </span><span>{{consulta?.tipoCarroceria || 'NÃO INFORMADO'}}</span></li>
    <li><span class="text-secondary">Nº da carroceria
      </span><span>{{consulta?.nrCarroceria || 'NÃO INFORMADO'}}</span></li>
    <li><span class="text-secondary">Quantidade de eixos
      </span><span>{{consulta?.numeroEixos || 'NÃO INFORMADO'}}</span></li>
    <li><span class="text-secondary">Eixo traseiro diferencial
      </span><span>{{consulta?.eixoTraseiroDiferencial || 'NÃO INFORMADO'}}</span></li>
    <li><span class="text-secondary">Terceiro eixo
      </span><span>{{consulta?.terceiroEixo || 'NÃO INFORMADO'}}</span></li>
    <li><span class="text-secondary">Cap. máx. de tração
      </span><span>{{consulta?.capacMaxTracao || 'NÃO INFORMADO'}}</span></li>
    <li><span class="text-secondary">Peso bruto total
      </span><span>{{consulta?.pesoBrutoTotal || 'NÃO INFORMADO'}}</span></li>
    <li><span class="text-secondary">Capacidade de carga
      </span><span>{{consulta?.capacidadeDeCarga || 'NÃO INFORMADO'}}</span></li>
  </ul>

  <h2 class="subtitle text-uppercase">Proprietários</h2>
  <ul class="card-list-striped">
    <li><span class="text-secondary">Tipo doc proprietário
      </span><span>{{consulta?.tipoDocProprietario || 'NÃO INFORMADO'}}</span></li>
  </ul>

  <h2 class="subtitle text-uppercase">Dados de importação</h2>
  <ul class="card-list-striped">
    <li><span class="text-secondary">Procedência
      </span><span>{{consulta?.procedencia || 'NÃO INFORMADO'}}</span></li>
    <li><span class="text-secondary">Data registro DI
      </span><span>{{consulta?.dataRegistroDi || 'NÃO INFORMADO'}}</span></li>
    <li><span class="text-secondary">Número DI </span><span>{{consulta?.numeroDi || 'NÃO INFORMADO'}}</span>
    </li>
    <li><span class="text-secondary">Número importadora
      </span><span>{{consulta?.numeroImportadora || 'NÃO INFORMADO'}}</span></li>
    <li><span class="text-secondary">Tipo doc importadora
      </span><span>{{consulta?.tipoDocImportadora || 'NÃO INFORMADO'}}</span></li>
  </ul>
</ng-container>

</app-card-consulta>
